import { useState, useEffect, useCallback } from 'react';

export const useIntersectionObserver = (options?: IntersectionObserverInit) => {
  const [isInView, setIsInView] = useState(false);
  const [element, setElement] = useState<Element | null>(null);

  const ref = useCallback((node: Element | null) => {
    setElement(node);
  }, []);

  const root = options?.root;
  const rootMargin = options?.rootMargin;
  const threshold = options?.threshold;
  // Serialize threshold so array values don't break React's Object.is dep check
  const thresholdKey = Array.isArray(threshold) ? threshold.join(',') : threshold;

  useEffect(() => {
    if (!element) return;

    const observer = new IntersectionObserver(([entry]) => {
      setIsInView(entry.isIntersecting);
    }, { root, rootMargin, threshold });

    observer.observe(element);
    return () => {
      observer.disconnect();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [element, root, rootMargin, thresholdKey]);

  return [ref, isInView] as const;
};
